<template>
  <div class="sc-calculator">
    <h3 class="sc-calculator-title"> Koľko si mesačne zarobíš? </h3>
    <p class="sc-calculator-help"> Posuň ikonky na čísla, na ktoré si trúfaš. </p>

    <div class="sc-calculator-groups">
      <div
        v-for="product in products"
        :key="product.name"
        class="sc-calculator-group"
      >
        <span class="sc-calculator-group-label">{{ product.name }} </span>
        <span class="sc-calculator-group-help">({{ product.help }})</span>
        <div class="sc-calculator-group-sliderwrap">
          <VueSlider
            v-model="product.quantity"
            class="sc-calculator-slider"
            v-bind="sliderOptions"
          />
        </div>
      </div>
    </div>

    <div class="sc-calculator-result">
      <div class="sc-calculator-amounts">
        <div class="sc-calculator-amount">
          <div class="sc-calculator-amount-value">{{ productReward }} € <span class="sc-calculator-amount-plus">+</span></div>
          <div class="sc-calculator-amount-help">Predpokladaná provízia</div>
        </div>
        <div class="sc-calculator-amount">
          <div class="sc-calculator-amount-value">{{ variableReward }} €</div>
          <div class="sc-calculator-amount-help">Variabilná zložka</div>
        </div>
      </div>
      <div class="sc-calculator-result-label">
        Pri zadanom objeme predpokladáme takýto mesačný zárobok.
      </div>
      <div class="sc-calculator-result-label2">
        Orientačná kalkulácia príjmu kalkulovaná pre poradcu na najvyššom kariérnom stupni WP4 s max. hodnotami provízie a priemernými dojednávanými sumami.
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

import productRewardsRaw from '@/data/rewardsFlat';

const productRewards = [...productRewardsRaw];
productRewards.reverse();

export default {
  components: {
    VueSlider,
  },
  data() {
    return {
      products: [
        {
          name: 'Životné poistenie',
          help: 'pri ročnom poistnom 360 €',
          reward: 345.6,
          quantity: 1,
          variableContent: 540,
          // targetSavings: 0,
          // targetInsurance: 360,
        },
        {
          name: 'Neživotné poistenie',
          help: 'pri ročnom poistnom 200 €',
          reward: 52.40,
          quantity: 1,
          variableContent: 200,
        },
      ],
      sliderOptions: {
        min: 0,
        max: 9,
        interval: 1,
        dotSize: 40,
        dotStyle: {
          backgroundColor: 'black',
          boxShadow: 'none',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '80% auto',
          backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'40.4\' height=\'40.4\' fill=\'%23fff\'%3E%3Cpath class=\'a\' d=\'M5 21.9v3.3h1.8V22h.7a1.7 1.7 0 011.7 1.7v1.6H21v-.8a2.5 2.5 0 012.5-2.5h1.7v1.7h-2.5v3.3h6.8v-3.3H27v-1.7h11a1.7 1.7 0 100-3.4H27v-1.7h2.6v-3.4h-6.8v3.4h2.5v1.7h-1.6A2.5 2.5 0 0121 16V15h-12v1.7a1.7 1.7 0 01-1.6 1.7h-.7v-3.4H5zm11.7-4.3a2.5 2.5 0 110 5.1h-4.2v-5z\'/%3E%3Cpath class=\'a\' d=\'M17.6 20.2a.8.8 0 00-.9-.9h-2.5V21h2.5a.8.8 0 00.9-.8zM34.6 16.8v-1.7a2.5 2.5 0 00-2.5-2.5h-.9v4.2zM34.6 23.6h-3.4v4.2h.9a2.5 2.5 0 002.5-2.6zM9.3 27H16v2.5H9.3zM9.3 10.9H16v2.5H9.3z\'/%3E%3C/svg%3E")',
        },
        tooltip: 'none',
        process: false,
        railStyle: {
          background: 'white',
        },
        marks: {
          0: { label: '0 ks' },
          3: { label: '3 ks' },
          6: { label: '6 ks' },
          9: { label: '9 ks' },
        },
        stepStyle: { display: 'none' },
        labelStyle: { marginTop: '20px', fontSize: '12px', opacity: '0.8' },
      },
    };
  },
  computed: {
    totalVariableContent() {
      const amount = this.products.reduce((pv, cv) => {
        const current = cv.variableContent * cv.quantity;
        return pv + current;
      }, 0);
      return amount;
    },
    variableReward() {
      const match = productRewards.find(
        (row) => this.totalVariableContent >= row[0],
      );
      return match[1];
    },
    productReward() {
      const amount = this.products.reduce((pv, cv) => {
        const current = cv.reward * cv.quantity;
        return pv + current;
      }, 0);
      return Math.round(amount);
    },
  },
};
</script>

<style lang="scss" scoped>
.sc-calculator {
  background-color: $primary;
  color: white;
  padding: 20px;
  @media screen and (min-width: $screen-md) {
    padding: 35px;
    box-shadow: 500px 0 0 $primary;
  }

  .sc-calculator-title {
    font-size: 24px;
    margin-bottom: 5px;
  }
  .sc-calculator-help {
    font-size: 14px;
    margin-bottom: 40px;
  }
  .sc-calculator-groups {
    @media screen and (min-width: $screen-md) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  .sc-calculator-group {
    flex: 0 0 48%;
    margin: 0 0 20px;
  }
  .sc-calculator-group-label {
    font-weight: 700;
  }
  .sc-calculator-group-help {
    display: block;
    font-size: 12px;
  }
  .sc-calculator-group-sliderwrap {
    margin-top: 5px;
    padding: 5px 30px 22px;
    background-color: rgba(black, 0.15);
    border-radius: 5px;
  }
  .sc-calculator-result {
    margin-top: 40px;
    background-color: white;
    background-image: url('../assets/patterns/check-pattern.svg');
    background-position: left bottom;
    background-repeat: repeat-x;
    background-size: 24px 22px;
    color: $gray-500;
    box-shadow: 0px 3px 56px #00000029;
    padding: 20px;
    margin-bottom: -40px;
    @media screen and (min-width: $screen-md) {
      padding: 25px 30px 50px;
      margin-bottom: -80px;
    }
  }
  .sc-calculator-result-label2 {
    color: $gray-300;
    font-size: 12px;
  }
  .sc-calculator-amount {
    display: inline-block;
    margin-bottom: 20px;
    line-height: 1;
    color: $gray-600;
    font-size: 14px;
    margin-right: 10px;
  }
  .sc-calculator-amount-value {
    font-size: 50px;
    font-weight: 100;
  }
  .sc-calculator-amount-plus {
    font-size: 80%;
  }
}
</style>
